import gamepad from "../../assets/img/products/gamepad.png";
import keys from "../../assets/img/products/keys.png";
import movies from "../../assets/img/products/movies-icon.png";
import shopping from "../../assets/img/products/shopping-bags.png";
import simcard from "../../assets/img/products/simcard.png";
import special from "../../assets/img/products/special-ticket.png";

const productsData = [
    {
        id: "p_1",
        title: "بطاقات التسوق",
        img: shopping,
        link: "#"
    },
    {
        id: "p_2",
        title: "الالعاب",
        img: gamepad,
        link: "#"
    },
    {
        id: "p_3",
        title: "البرامج والافلام",
        img: movies,
        link: "#"
    },
    {
        id: "p_4",
        title: "مفاتيح البرامج",
        img: keys,
        link: "#"
    },
    {
        id: "p_5",
        title: "بطاقات الاتصال",
        img: simcard,
        link: "#"
    },
    {
        id: "p_6",
        title: "منتجات مميزة",
        img: special,
        link: "#"
    }
];

export default productsData;
